(function ($) {
    'use strict';

    var gallerySelector = [
        '.bmh-inner-content .page-body img[data-id]',
        '.bmh-inner-content .page-body1 img[data-id]',
        '.bmh-inner-content .bmh-rich-content img[data-id]',
        '.bmh-inner-content .tab-pane img[data-id]',
        '.bmh-inner-content .bmh-news-article img[data-id]',
        '.bmh-inner-content .section-item-body img[data-id]'
    ].join(',');

    function isImageUrl(url) {
        return /\.(avif|bmp|gif|jpe?g|png|svg|webp)(?:[?#].*)?$/i.test(url || '');
    }

    function imageSource(image) {
        return image.currentSrc
            || image.getAttribute('src')
            || image.getAttribute('data-src')
            || '';
    }

    function prepareImage(image) {
        var $image = $(image);

        if (
            $image.attr('data-bmh-gallery-ready')
            || $image.is('[data-no-gallery], .no-gallery')
            || $image.closest('[data-bmh-gallery-ignore], .no-gallery, button').length
        ) {
            return;
        }

        var source = imageSource(image);

        if (!source) {
            return;
        }

        var $visual = $image.parent('picture').length
            ? $image.parent('picture')
            : $image;
        var $link = $visual.parent('a');

        if ($link.length) {
            var linkUrl = $link.attr('href') || '';

            if (linkUrl && linkUrl !== source && !isImageUrl(linkUrl)) {
                return;
            }
        } else {
            $visual.wrap(
                $('<a/>', {
                    href: source,
                    class: 'bmh-content-gallery__link auto-zoom-img'
                })
            );
            $link = $visual.parent();
        }

        $link
            .addClass('bmh-content-gallery__link auto-zoom-img')
            .attr({
                href: $link.attr('href') || source,
                'data-fancybox': 'bmh-inner-content-gallery',
                'data-caption': $image.attr('alt') || $image.attr('title') || '',
                'aria-label': 'Open image in gallery'
            });

        $image.attr('data-bmh-gallery-ready', 'true');
    }

    function initializeGallery(root) {
        if (!$.fancybox) {
            return;
        }

        $(root || document)
            .find(gallerySelector)
            .addBack(gallerySelector)
            .each(function () {
                prepareImage(this);
            });

        $('[data-fancybox="bmh-inner-content-gallery"]').fancybox({
            loop: true,
            protect: false,
            buttons: [
                'zoom',
                'slideShow',
                'fullScreen',
                'download',
                'thumbs',
                'close'
            ],
            animationEffect: 'fade',
            transitionEffect: 'slide',
            mobile: {
                clickContent: 'toggleControls',
                clickSlide: 'close'
            }
        });
    }

    function initializeMediaFallbacks(root) {
        $(root || document)
            .find('[data-bmh-media-image]')
            .addBack('[data-bmh-media-image]')
            .each(function () {
                var image = this;
                var $image = $(image);

                if ($image.attr('data-bmh-media-ready')) {
                    return;
                }

                $image.attr('data-bmh-media-ready', 'true');

                var showFallback = function () {
                    $image.attr('hidden', true);
                    $image.siblings('[data-bmh-media-fallback]').prop('hidden', false);
                };

                image.addEventListener('error', showFallback, { once: true });

                if (image.complete && image.naturalWidth === 0) {
                    showFallback();
                }
            });
    }

    function initializeInnerSocial() {
        var socialSource = document.querySelector('[data-bmh-inner-social-source]');

        if (!socialSource) {
            return;
        }

        var heading = document.querySelector(
            '.bmh-inner-content .bmh-page-intro,'
            + '.bmh-inner-content .bmh-inner-title,'
            + '.bmh-inner-content .section-title'
        );

    if (!heading) {
      return;
    }

    if (heading.querySelector('.bmh-inner-social')) {
      socialSource.remove();
      return;
    }

    heading.classList.add('bmh-inner-heading-with-social');

        while (socialSource.firstChild) {
            heading.appendChild(socialSource.firstChild);
        }

        socialSource.remove();
    }

    $(function () {
        initializeInnerSocial();
        initializeGallery(document);
        initializeMediaFallbacks(document);

        if ('MutationObserver' in window) {
            var content = document.querySelector('.bmh-inner-content');

            if (content) {
                new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
                            if (node.nodeType === 1) {
                                initializeGallery(node);
                                initializeMediaFallbacks(node);
                            }
                        });
                    });
                }).observe(content, {
                    childList: true,
                    subtree: true
                });
            }
        }
    });
})(jQuery);
